import { render, staticRenderFns } from "./BaseRateCombinationDiagnosis.vue?vue&type=template&id=64ae2d99&scoped=true&"
import script from "./BaseRateCombinationDiagnosis.vue?vue&type=script&lang=js&"
export * from "./BaseRateCombinationDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./BaseRateCombinationDiagnosis.vue?vue&type=style&index=0&id=64ae2d99&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ae2d99",
  null
  
)

export default component.exports